import { createContext, ReactNode, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { get, remove, set } from '@/utils/storage/adapters/localStorageAdapter'

interface AuthContextType {
  isLoggedIn: boolean
  login: (token: string) => void
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

interface JWTProviderProps {
  children: ReactNode
}

export const JWTProvider = ({ children }: JWTProviderProps) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(!!get('token'))
  const navigate = useNavigate()

  const login = (token: string) => {
    set('token', token)
    setIsLoggedIn(true)
    navigate('/home')
  }

  const logout = () => {
    remove('token')
    setIsLoggedIn(false)
    navigate('/login', { replace: true })
  }

  const isTokenExpired = (token: string): boolean => {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const exp = payload.exp * 1000
    return Date.now() >= exp
  }

  useEffect(() => {
    const token = get('token')
    if (token) {
      if (isTokenExpired(token)) {
        logout()
      }
    } else {
      setIsLoggedIn(false)
    }
  }, [])

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>{children}</AuthContext.Provider>
  )
}

export default AuthContext
